const RAIL_WIDTH = 160;
const MIN_SIDE_GAP = 24;
const MIN_OUTER_MARGIN = 18;
const DEFAULT_TOP_OFFSET = 104;
const RAIL_MIN_VISIBLE_HEIGHT = 360;
const MIN_SCROLL_BEFORE_SHOW = 180;
const MAX_SCROLL_BEFORE_SHOW = 320;
const VIEWPORT_SCROLL_RATIO = 0.22;
const UPDATE_EVENT = 'wla-side-rail-updated';

function viewportWidth() {
  return window.innerWidth || document.documentElement.clientWidth || 0;
}

function viewportHeight() {
  return window.innerHeight || document.documentElement.clientHeight || 0;
}

function visibleRect(element) {
  if (!element) return null;
  const rect = element.getBoundingClientRect();
  if (rect.width <= 0 || rect.height <= 0) return null;
  return rect;
}

function candidateAnchorRects() {
  return Array.from(
    document.querySelectorAll(
      '.post-header--default, .post-header--featured, .post-header__img-wrapper, .post-content > p, .post-content > h2, .post-content > figure:not(.kg-width-full)'
    )
  )
    .map(visibleRect)
    .filter(Boolean)
    .filter((rect) => rect.width >= 420 && rect.width < viewportWidth() - 32);
}

function contentAnchorRect() {
  const rects = candidateAnchorRects();
  if (!rects.length) return null;

  return rects.reduce((widest, rect) => (rect.width > widest.width ? rect : widest), rects[0]);
}

function topOffset() {
  const header = visibleRect(document.querySelector('.header'));
  const announcement = visibleRect(document.querySelector('.wla-announcement-bar-root, #announcement-bar-root'));
  const bottom = Math.max(header?.bottom || 0, announcement?.bottom || 0, 72);
  return Math.max(DEFAULT_TOP_OFFSET, Math.round(bottom + 24));
}

function hasEnoughReadingSpace(anchorRect) {
  const leftSpace = anchorRect.left;
  const rightSpace = viewportWidth() - anchorRect.right;
  const required = RAIL_WIDTH + MIN_SIDE_GAP + MIN_OUTER_MARGIN;

  return leftSpace >= required && rightSpace >= required;
}

function hasEnoughArticleHeight(top) {
  const post = document.querySelector('article.post');
  const postRect = visibleRect(post);
  if (!postRect) return false;

  return postRect.bottom - top >= RAIL_MIN_VISIBLE_HEIGHT;
}

function hasScrolledEnough() {
  const scrollY = window.scrollY || document.documentElement.scrollTop || 0;
  const trigger = Math.min(
    MAX_SCROLL_BEFORE_SHOW,
    Math.max(MIN_SCROLL_BEFORE_SHOW, Math.round(viewportHeight() * VIEWPORT_SCROLL_RATIO))
  );

  return scrollY >= trigger;
}

function activateRail(rail, anchorRect, top) {
  if (rail.dataset.wlaPlacementDisabled && rail.dataset.wlaPlacementDisabled !== 'app-promo-rotation') return;

  const right = Math.max(MIN_OUTER_MARGIN, viewportWidth() - anchorRect.right - MIN_SIDE_GAP - RAIL_WIDTH);
  rail.style.setProperty('--wla-side-rail-right', `${Math.round(right)}px`);
  rail.style.setProperty('--wla-side-rail-top', `${top}px`);
  rail.hidden = false;
  rail.classList.add('is-active');

  if (rail.dataset.wlaSideRailShown !== 'true' && window.WLAMonetization?.sendEvent) {
    rail.dataset.wlaSideRailShown = 'true';
    window.WLAMonetization.sendEvent('experiment_shown', rail, {
      source: 'article-side-rail',
      viewportWidth: viewportWidth(),
      anchorWidth: Math.round(anchorRect.width)
    });
  }
}

function deactivateRail(rail) {
  rail.classList.remove('is-active');
  rail.hidden = true;
}

function updateRails() {
  const anchorRect = contentAnchorRect();
  const top = topOffset();
  const rails = Array.from(document.querySelectorAll('[data-wla-side-rail-ad]'));
  if (!rails.length) return;

  rails.forEach((rail) => {
    if (
      (rail.dataset.wlaPlacementDisabled && rail.dataset.wlaPlacementDisabled !== 'app-promo-rotation') ||
      rail.dataset.wlaSideRailAd !== 'right' ||
      !anchorRect ||
      viewportHeight() < 640 ||
      !hasScrolledEnough() ||
      !hasEnoughReadingSpace(anchorRect) ||
      !hasEnoughArticleHeight(top)
    ) {
      deactivateRail(rail);
      return;
    }

    activateRail(rail, anchorRect, top);
  });

  window.dispatchEvent(new CustomEvent(UPDATE_EVENT));
}

function scheduleUpdate() {
  if (window.__wlaSideRailFrame) return;
  window.__wlaSideRailFrame = window.requestAnimationFrame(() => {
    window.__wlaSideRailFrame = null;
    updateRails();
  });
}

export function initArticleSideRails() {
  if (!document.querySelector('[data-wla-side-rail-ad]')) return;

  scheduleUpdate();
  window.addEventListener('resize', scheduleUpdate);
  window.addEventListener('orientationchange', scheduleUpdate);
  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('load', scheduleUpdate, { once: true });
  setTimeout(scheduleUpdate, 750);
  setTimeout(scheduleUpdate, 2500);
}
